import { ApplicationPhoto } from "@entities/photos";
import { API_PREFIX, API_URL } from "..";

export const useGetUserAvatar = (
  userPhotos: ApplicationPhoto[] | undefined,
  isShortcut: boolean = false,
  userTgID?: number,
): string => {
  if (userPhotos && userPhotos.length > 0) {
    const latestPhoto = userPhotos[0];
    const photoName = isShortcut ? latestPhoto.shortcut_name : latestPhoto.name;
    return `${API_URL}${API_PREFIX}/photos/${photoName}`;
  } else if (userTgID) {
    return `${API_URL}${API_PREFIX}/users/avatar/${userTgID}`;
  };

  return "";
};
